import ALGORITIM_EXT_1 from "./ALGORITIM_EXT_1";
export default {
  ALGORITIM_EXT_1,
};
